<template>
  <div class="page">
    <BreadCrumbs :items="[{ title: 'Заказы', url: '/orders' }]" />
    <div class="row">
      <div class="col d-flex align-center">
        <h1 class="font-lg">Заказы</h1>
      </div>
    </div>
    <OrdersTable mode="admin" />
  </div>
</template>

<script>
import OrdersTable from '@/components/orders/OrdersTable.vue';

// Все заказы для админа: смена статуса «Ожидает оплаты» → «Оплачен» / «Отменён» (Э-8).
export default {
  name: 'Orders',
  metaInfo: { title: 'Заказы' },
  components: { OrdersTable },
};
</script>
